module.exports = __webpack_public_path__ + "img/CersoYeetAlt.0ebf7df0.png";